
@switch (state$ | async) {
  @case ('reachable') {
    <ng-container
    [ngTemplateOutlet]="main"></ng-container>
  }
  @case ('guest') {
    <ng-container
    [ngTemplateOutlet]="login"></ng-container>
  }
}

<ng-template #main>
  <div class="nav">
    <app-navbar></app-navbar>
  </div>
  <main class="main">
    <app-side-nav>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </app-side-nav>
  </main>
</ng-template>

<ng-template #login>
  <app-login></app-login>
</ng-template>
